import { Form, Input } from 'antd'
import { FC, memo } from 'react'
import { CustomizeFeeRateProps } from '@/hooks/fee/validator'
import { useValidateFilFeeFields } from '@/hooks/fee/filecoin'

const FilFeeRate: FC<CustomizeFeeRateProps> = props => {
  const { unit, value } = props

  const { errorMap, handleChangeGasLimit, handleChangeMaxPriorityFee, handleChangeMaxFee } =
    useValidateFilFeeFields(props)

  return (
    <Form layout="vertical">
      <Form.Item
        label={`Gas Fee Cap (${unit})`}
        validateStatus={errorMap.maxFee?.message && 'error'}
        help={errorMap.maxFee?.message}
      >
        <Input value={value.maxFee} onChange={evt => handleChangeMaxFee(evt.target.value)} />
      </Form.Item>
      <Form.Item
        label={`Gas Premiun (${unit})`}
        validateStatus={errorMap.maxPriorityFee?.message && 'error'}
        help={errorMap.maxPriorityFee?.message}
      >
        <Input
          value={value.maxPriorityFee}
          onChange={evt => handleChangeMaxPriorityFee(evt.target.value)}
        />
      </Form.Item>
      <Form.Item
        label="Gas Limit"
        validateStatus={errorMap.gasLimit?.message && 'error'}
        help={errorMap.gasLimit?.message}
      >
        <Input value={value.gasLimit} onChange={evt => handleChangeGasLimit(evt.target.value)} />
      </Form.Item>
    </Form>
  )
}

export default memo(FilFeeRate)
